/** model for agent profile entity*/
export interface AgentProfileEntity {
  /** The unique profile name associated with AAD token. */
  aadUpn: string;

  /** The agent id/puid. */
  msaPuid: string;

  /** The encrypted agent id/puid. */
  encryptedPuid: string;

  /** Sip address of the agent. Used for channels. */
  sipAddress: string;

  /** The email address of agent. */
  email: string;

  /** The first name of agent. */
  firstName: string;

  /** The last name of agent. */
  lastName: string;

  /** The vendor site code associated with the agent. */
  siteId: string;

  /** The site the agent is associated with. */
  siteName: string;

  /** The vendor company agent is associated with. */
  supplierName: string;

  /** The tier the agent belongs to. */
  tier: string;

  /** Whether the agent has SFB license. */
  isSfbEnabled: boolean;

  /** The locales supported by the agent. */
  supportedLocales: string[];

  /** Set of all channels which the agent can support like phone/chat etc. */
  supportedChannels: SupportChannel[];

  /** Set of all support area path which the agent can support like Azure/Learning/Developer etc. */
  supportAreaPaths: string[];

  /** Any extension properties related to channels. */
  extensionProperties: { [key: string]: string };

  /** Restricted Access Programs that the agent is part of */
  restrictedAccessPrograms?: string[];

  /** Unknown. */
  id: string;

  /** The display name for the agent. */
  name: string;

  /** The time when agent profile was created. */
  createdDateTime: string;

  /** The time when agent profile was last modified. */
  lastModifiedDateTime: string;

  /** The user who created the agent profile. */
  createdBy: string;

  /** The user who last modified the agent profile. */
  lastModifiedBy: string;

  /** States if the agent is in active role. */
  isActive: boolean;

  /** Unknown. */
  versionNumber: string;

  /** Unknown. */
  type: string;

  /** The url for a picture of the user. */
  imageUrl: string;
}

/** model for agent profile as returned by agent service call*/
export interface AgentProfileEntityModel {
  /** The unique profile name associated with AAD token. */
  AadUpn: string;

  /** The agent id/puid. */
  MsaPuid: string;

  /** The encrypted puid of the agent. */
  EncryptedPuid: string;

  /** Sip address of the agent. Used for channels. */
  SipAddress: string;

  /** The email address of agent. */
  Email: string;

  /** The first name of agent. */
  FirstName: string;

  /** The last name of agent. */
  LastName: string;

  /** The vendor site code associated with the agent. */
  SiteId: string;

  /** The site the agent is associated with. */
  SiteName: string;

  /** The vendor company agent is associated with. */
  SupplierName: string;

  /** The tier the agent belongs to. */
  Tier: string;

  /** Whether the agent has SFB license. */
  IsSfbEnabled: boolean;

  /** The locales supported by the agent. */
  SupportedLocales: string[];

  /** Set of all channels which the agent can support like phone/chat etc. */
  SupportedChannels: SupportChannel[];

  /** Set of all support area path which the agent can support like Azure/Learning/Developer etc. */
  SupportAreaPaths: string[];

  /** Any extension properties related to channels. */
  ExtensionProperties: { [key: string]: string };

  /** Restricted Access Programs that the agent is part of */
  RestrictedAccessPrograms?: string[];

  /** Unknown. */
  id: string;

  /** The display name for the agent. */
  Name: string;

  /** The time when agent profile was created. */
  CreatedDateTime: string;

  /** The time when agent profile was last modified. */
  LastModifiedDateTime: string;

  /** The user who created the agent profile. */
  CreatedBy: string;

  /** The user who last modified the agent profile. */
  LastModifiedBy: string;

  /** States if the agent is in active role. */
  IsActive: boolean;

  /** Unknown. */
  VersionNumber: string;

  /** Unknown. */
  Type: string;

  /** The url for a picture of the user. */
  ImageUrl: string;
}

export interface SupportChannel {
  /** Type of channel. */
  ChannelType: string;

  /** Any attributes which define the channel. */
  Attributes: { [key: string]: string };
}

class Placeholder {
  // BUGBUG: this file breaks Karma w/ odd blank SourceMap files
  // So creating blank class to emit some code
}
